import { comparisonData } from '@/mocks/comparisonData';

export default function ComparisonTable() {
  return (
    <section id="spreadsheet" className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Why Basetao Spreadsheet Resources Outperform Normal Search
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            A side-by-side comparison showing how our organized resource hub delivers a superior experience compared to generic web searching.
          </p>
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200/70">
          <table className="w-full">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 text-xs font-semibold text-foreground-700 uppercase tracking-wider">Feature</th>
                <th className="text-left px-5 py-4 text-xs font-semibold text-accent-700 uppercase tracking-wider">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-database-2-line text-sm"></i>
                    Basetao Spreadsheet Resource
                  </span>
                </th>
                <th className="text-left px-5 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-search-line text-sm"></i>
                    Normal Search
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.feature} className={`border-t border-background-200/70 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-white'}`}>
                  <td className="px-5 py-3.5 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-5 py-3.5 text-sm text-accent-700">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                      {row.basetaoResource}
                    </span>
                  </td>
                  <td className="px-5 py-3.5 text-sm text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-close-circle-fill text-foreground-400 text-sm"></i>
                      {row.normalSearch}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}